
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ChooseRole from './pages/guest/auth/ChooseRole';
import AgentSignUp from './pages/guest/auth/AgentSignUp';
import SignIn from './pages/guest/auth/SignIn';
import VerifyCode from './pages/guest/auth/VerifyCode';
import ForgotPassword from './pages/guest/auth/ForgotPassword';
import ResetPassword from './pages/guest/auth/ResetPassword';
import TermsOfService from './pages/guest/TermsOfService';
import Dashboard from './pages/agents/Dashboard';
import CommissionWithdrawal from './pages/agents/CommissionWithdrawal';
import Settings from './pages/agents/Settings';
import Home from './pages/agents/Home';
import About from './pages/agents/About';
import NewRegistration from './pages/agents/NewRegistration';
import OthersClients from './pages/agents/OthersClients';
import StudentsClients from './pages/agents/StudentsClients';
import EditClient from './pages/agents/EditClient';
import EditStudent from './pages/agents/EditStudent';
import InsuranceChoice from './pages/agents/InsuranceChoice';
import InsuranceHero from './pages/agents/InsuranceHero';
import TripSecureInsurance from './pages/agents/TripSecureInsurance';
import TravelInsurance from './pages/agents/TravelInsurance';
import LifeInsurance from './pages/agents/LifeInsurance';
import GeneralInsurance from './pages/agents/GeneralInsurance';
import Checkout from './pages/agents/Checkout';
import EventMediaSales from './pages/agents/EventMediaSales';
import ConferenceTradeMission from './pages/agents/ConferenceTradeMission';
import EventsListing from './pages/agents/EventsListing';
import EventDetails from './pages/agents/EventDetails';
import EventRegistrationRouter from './pages/agents/EventRegistrationRouter';
import AgentEventGuestDetails from './pages/agents/AgentEventGuestDetails';
import AgentEventPaymentPlaceholder from './pages/agents/AgentEventPaymentPlaceholder';
import AgentConferenceRegistrationSuccess from './pages/agents/AgentConferenceRegistrationSuccess';
import PurchasedEvents from './pages/agents/PurchasedEvents';
import InsurancePurchases from './pages/agents/InsurancePurchases';
import AuthenticatedLayout from './layout/AuthenticatedLayout';
import PublicRoute from './components/PublicRoute';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes - Redirect to dashboard if authenticated */}
        <Route path="/" element={
          <PublicRoute>
            <Home />
          </PublicRoute>
        } />
        <Route path="/signin" element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        } />
        <Route path="/about" element={
          <PublicRoute>
            <About />
          </PublicRoute>
        } />
        
        <Route path="/signup" element={
          <PublicRoute>
            <ChooseRole />
          </PublicRoute>
        } />
        <Route path="/verify" element={
          <PublicRoute>
            <VerifyCode />
          </PublicRoute>
        } />
        <Route path="/forgot-password" element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        } />
        <Route path="/forgot-password/reset" element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        } />
        <Route path="/signup/riders" element={
          <PublicRoute>
            <AgentSignUp type="rider" />
          </PublicRoute>
        } />
        <Route path="/signup/general-agent" element={
          <PublicRoute>
            <AgentSignUp type="general" />
          </PublicRoute>
        } />
        <Route path="/signup/direct-agent" element={
          <PublicRoute>
            <AgentSignUp type="direct" />
          </PublicRoute>
        } />
        <Route path="/terms-of-service" element={
          <PublicRoute>
            <TermsOfService />
          </PublicRoute>
        } />

        {/* Authenticated Routes - Require authentication */}

        <Route path="/dashboard" element={
          <AuthenticatedLayout>
            <Dashboard />
          </AuthenticatedLayout>
        } />
        <Route path="/commission" element={
          <AuthenticatedLayout>
            <CommissionWithdrawal />
          </AuthenticatedLayout>
        } />
        <Route path="/commission-withdrawal" element={
          <AuthenticatedLayout>
            <CommissionWithdrawal />
          </AuthenticatedLayout>
        } />
        <Route path="/settings" element={
          <AuthenticatedLayout>
            <Settings />
          </AuthenticatedLayout>
        } />
        <Route path="/new-registration" element={
          <AuthenticatedLayout>
            <NewRegistration />
          </AuthenticatedLayout>
        } />
        <Route path="/others-clients" element={
          <AuthenticatedLayout>
            <OthersClients />
          </AuthenticatedLayout>
        } />
        <Route path="/edit-client/:slug" element={
          <AuthenticatedLayout>
            <EditClient />
          </AuthenticatedLayout>
        } />
        <Route path="/edit-student/:slug" element={
          <AuthenticatedLayout>
            <EditStudent />
          </AuthenticatedLayout>
        } />
        <Route path="/students-clients" element={
          <AuthenticatedLayout>
            <StudentsClients />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/choose" element={
          <AuthenticatedLayout>
            <InsuranceChoice />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/purchases" element={
          <AuthenticatedLayout>
            <InsurancePurchases />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/road-trip" element={
          <AuthenticatedLayout>
            <TripSecureInsurance />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/travel" element={
          <AuthenticatedLayout>
            <TravelInsurance />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/life" element={
          <AuthenticatedLayout>
            <LifeInsurance />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/general" element={
          <AuthenticatedLayout>
            <GeneralInsurance />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/tripsecure" element={
          <AuthenticatedLayout>
            <InsuranceHero />
          </AuthenticatedLayout>
        } />
        <Route path="/insurance/checkout" element={
          <AuthenticatedLayout>
            <Checkout />
          </AuthenticatedLayout>
        } />
        {/* Event & Media Sales: most specific routes first so matching is unambiguous */}
        <Route path="/event-media-sales/event-details/:slug/register" element={
          <AuthenticatedLayout>
            <EventRegistrationRouter />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/event-details/:slug/book" element={
          <AuthenticatedLayout>
            <EventRegistrationRouter />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/event-details/:slug/guest-details" element={
          <AuthenticatedLayout>
            <AgentEventGuestDetails />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/event-details/:slug/event-payment" element={
          <AuthenticatedLayout>
            <AgentEventPaymentPlaceholder />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/event-details/:slug/registration-success" element={
          <AuthenticatedLayout>
            <AgentConferenceRegistrationSuccess />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/event-details/:slug" element={
          <AuthenticatedLayout>
            <EventDetails />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/conference-trade-mission" element={
          <AuthenticatedLayout>
            <ConferenceTradeMission />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/conference" element={
          <AuthenticatedLayout>
            <ConferenceTradeMission />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/trade-mission" element={
          <AuthenticatedLayout>
            <ConferenceTradeMission />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/events" element={
          <AuthenticatedLayout>
            <EventsListing />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales/purchased-events" element={
          <AuthenticatedLayout>
            <PurchasedEvents />
          </AuthenticatedLayout>
        } />
        <Route path="/event-media-sales" element={
          <AuthenticatedLayout>
            <EventMediaSales />
          </AuthenticatedLayout>
        } />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
